module.exports = __webpack_public_path__ + "media/images/Canada-groom-image2-390a1a306c88a4d7036ccc4317b08262.jpg";